import React from 'react';
import './KingdomSelector.css';
import KingdomButton from './KingdomButton';

class KingdomSelector extends React.Component
{
    onKingdomSelected = (faction, character) => {
        this.props.onKingdomSelected(faction, character);
    }

    render()
    {
        return (
            <div className='kingdom-selector'>
                {
                    this.props.characters.map((character) => {
                        return (
                            <KingdomButton key={character.character} faction={character.faction} character={character.character} isSelected={character.character === this.props.selectedCharacter} onSelected={this.onKingdomSelected} />
                        );
                    })
                }
            </div>
        );
    }
}

export default KingdomSelector;